import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-125">
          <div data-id="element-126">
            <h3 className="text-xl font-bold text-pink-400 mb-4" data-id="element-127">
              Sunton Florist
            </h3>
            <p className="text-gray-400 mb-4" data-id="element-128">
              Kenya's first tech-driven flower subscription service for homes,
              relationships, and businesses.
            </p>
            <div className="flex space-x-4" data-id="element-129">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-130">
                <FacebookIcon className="h-5 w-5" data-id="element-131" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-132">
                <InstagramIcon className="h-5 w-5" data-id="element-133" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-134">
                <TwitterIcon className="h-5 w-5" data-id="element-135" />
              </a>
            </div>
          </div>
          <div data-id="element-136">
            <h4 className="text-lg font-semibold mb-4" data-id="element-137">Quick Links</h4>
            <ul className="space-y-2" data-id="element-138">
              <li data-id="element-139">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-140">
                  Home
                </a>
              </li>
              <li data-id="element-141">
                <a href="#how-it-works" className="text-gray-400 hover:text-white transition-colors" data-id="element-142">
                  How It Works
                </a>
              </li>
              <li data-id="element-143">
                <a href="#plans" className="text-gray-400 hover:text-white transition-colors" data-id="element-144">
                  Subscription Plans
                </a>
              </li>
              <li data-id="element-145">
                <a href="#pricing" className="text-gray-400 hover:text-white transition-colors" data-id="element-146">
                  Pricing
                </a>
              </li>
              <li data-id="element-147">
                <a href="#faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-148">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-149">
            <h4 className="text-lg font-semibold mb-4" data-id="element-150">Contact Us</h4>
            <ul className="space-y-2" data-id="element-151">
              <li className="flex items-start" data-id="element-152">
                <PhoneIcon className="h-5 w-5 text-pink-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-153" />
                <span className="text-gray-400" data-id="element-154">+254 700 123 456</span>
              </li>
              <li className="flex items-start" data-id="element-155">
                <MailIcon className="h-5 w-5 text-pink-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-156" />
                <span className="text-gray-400" data-id="element-157">hello@suntonflorist.co.ke</span>
              </li>
              <li className="flex items-start" data-id="element-158">
                <MapPinIcon className="h-5 w-5 text-pink-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-159" />
                <span className="text-gray-400" data-id="element-160">
                  Kileleshwa, Nairobi, Kenya
                </span>
              </li>
            </ul>
          </div>
          <div data-id="element-161">
            <h4 className="text-lg font-semibold mb-4" data-id="element-162">Subscribe to Updates</h4>
            <p className="text-gray-400 mb-4" data-id="element-163">
              Get the latest news and special offers
            </p>
            <div className="flex flex-col space-y-3" data-id="element-164">
              <input type="email" placeholder="Your email address" className="px-4 py-2 rounded-md bg-gray-800 border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent" data-id="element-165" />
              <button className="px-4 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-166">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-167">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-168">
            © {new Date().getFullYear()} Sunton Florist. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-169">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-170">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-171">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-172">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}